module.exports = __webpack_public_path__ + "img/p3_3.34d8ef5a.webp";